import { render } from "./Doctor.vue?vue&type=template&id=230b0786&ts=true&lang=pug"
import script from "./Doctor.vue?vue&type=script&setup=true&lang=ts"
export * from "./Doctor.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__